<div class="table">
    <div class="container">
      <div class="y-axis">
        <div class="visualization-name">DATA TABLE</div>

        <div class="message">
          1. Find yourself<br>
          2. Touch your icon on the screen<br>
          3. Explore more! Look below the table<br>
        </div>
      </div>
      <div class="visualization default-table-theme">
        <div class="visualization-area">
          <dvl-visualization [data]="data" #visualization></dvl-visualization>
        </div>
        <div class="x-axis-buttons">
            <app-gv-button-group
                label="Sort by"
                [variables]="variables"
                [type]="orderType"
                [defaultVariable]="defaultOrderVariable"
                (variableChange)="variableChanged($event, 'order')">
            </app-gv-button-group>
          </div>
      </div>
      <div class="graphic-variables-selection">

      </div>
    </div>
  </div>
